import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class FormHeader extends Component {
  render() {
    let className = cx({
      formHeader: true,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
